import { useSyncExternalStore } from 'react';

// FIN-1211: a single global, admin-controlled flag that reveals archived
// companies/vessels in every select dropdown (and report select) at once.
// The selectOptions API hub reads it at call time, so all select_options
// fetches honour it without per-call-site changes. Off by default.
const STORAGE_KEY = 'finvisor:show_archived_in_selects';

const read = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch (e) {
    return false;
  }
};

let current = read();
const listeners = new Set();

export const getShowArchivedInSelects = () => current;

export const setShowArchivedInSelects = (value) => {
  const next = !!value;
  if (next === current) return;
  current = next;
  try {
    localStorage.setItem(STORAGE_KEY, next ? 'true' : 'false');
  } catch (e) {
    // ignore storage failures (private mode etc.) — in-memory value still works
  }
  listeners.forEach((listener) => listener());
};

// Flipping the flag reloads the page so every list, select and report re-fetches
// with the new value (companies list, GraphQL selects, select_options, reports).
export const setShowArchivedInSelectsAndReload = (value) => {
  setShowArchivedInSelects(value);
  if (typeof window !== 'undefined' && window.location) {
    window.location.reload();
  }
};

export const subscribeShowArchivedInSelects = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

// React 18 store binding: components re-render when the flag flips.
export const useShowArchivedInSelects = () =>
  useSyncExternalStore(subscribeShowArchivedInSelects, getShowArchivedInSelects);
